/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BudgetVersionDto } from '../models/budget-version-dto';
import { getBudgetVersion } from '../fn/budget-versions/get-budget-version';
import { GetBudgetVersion$Params } from '../fn/budget-versions/get-budget-version';
import { setBudgetVersionActive } from '../fn/budget-versions/set-budget-version-active';
import { SetBudgetVersionActive$Params } from '../fn/budget-versions/set-budget-version-active';
import { setBudgetVersionCurrent } from '../fn/budget-versions/set-budget-version-current';
import { SetBudgetVersionCurrent$Params } from '../fn/budget-versions/set-budget-version-current';
import { updateBudgetVersion } from '../fn/budget-versions/update-budget-version';
import { UpdateBudgetVersion$Params } from '../fn/budget-versions/update-budget-version';

@Injectable({ providedIn: 'root' })
export class BudgetVersionsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBudgetVersion()` */
  static readonly GetBudgetVersionPath = '/v0/budget-versions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBudgetVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBudgetVersion$Response(params: GetBudgetVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<BudgetVersionDto>> {
    return getBudgetVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBudgetVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBudgetVersion(params: GetBudgetVersion$Params, context?: HttpContext): Observable<BudgetVersionDto> {
    return this.getBudgetVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<BudgetVersionDto>): BudgetVersionDto => r.body)
    );
  }

  /** Path part for operation `updateBudgetVersion()` */
  static readonly UpdateBudgetVersionPath = '/v0/budget-versions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBudgetVersion()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBudgetVersion$Response(params: UpdateBudgetVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateBudgetVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBudgetVersion$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBudgetVersion(params: UpdateBudgetVersion$Params, context?: HttpContext): Observable<void> {
    return this.updateBudgetVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setBudgetVersionActive()` */
  static readonly SetBudgetVersionActivePath = '/v0/budget-versions/{id}/active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setBudgetVersionActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  setBudgetVersionActive$Response(params: SetBudgetVersionActive$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setBudgetVersionActive(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setBudgetVersionActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setBudgetVersionActive(params: SetBudgetVersionActive$Params, context?: HttpContext): Observable<void> {
    return this.setBudgetVersionActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setBudgetVersionCurrent()` */
  static readonly SetBudgetVersionCurrentPath = '/v0/budget-versions/{id}/current';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setBudgetVersionCurrent()` instead.
   *
   * This method doesn't expect any request body.
   */
  setBudgetVersionCurrent$Response(params: SetBudgetVersionCurrent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setBudgetVersionCurrent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setBudgetVersionCurrent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setBudgetVersionCurrent(params: SetBudgetVersionCurrent$Params, context?: HttpContext): Observable<void> {
    return this.setBudgetVersionCurrent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
